import { useTheme } from '@mui/material/styles';

const TERTIARY = { light: '#3e5c8a', dark: '#9bb0d9' };

export interface CategoryColors {
  overview: string;
  inventory: string;
  procurement: string;
  inboundQuality: string;
  outbound: string;
  production: string;
  jobWork: string;
  weightProduction: string;
  adjustments: string;
  approvals: string;
  billing: string;
}

/** One on-brand color per dashboard tab, resolved off the active theme so charts stay correct in
 * both light and dark mode without a separate hardcoded palette. */
export function useCategoryColors(): CategoryColors {
  const theme = useTheme();
  const p = theme.palette;

  return {
    overview: p.primary.main,
    inventory: p.info.main,
    procurement: p.secondary.main,
    inboundQuality: theme.palette.mode === 'dark' ? TERTIARY.dark : TERTIARY.light,
    outbound: p.success.main,
    production: p.warning.main,
    // Sits alongside Production conceptually (both are "making something"), so it borrows the same
    // warning hue one step darker/lighter rather than introducing a new brand colour.
    jobWork: theme.palette.mode === 'dark' ? p.warning.light : p.warning.dark,
    // A different base hue (info) from Production/Job Work's warning tones above, one shade off
    // Inventory's plain info.main, same "borrow-and-shift" pattern Job Work uses on warning —
    // keeps three production-adjacent tabs visually distinct rather than all reading as orange.
    weightProduction: theme.palette.mode === 'dark' ? p.info.light : p.info.dark,
    adjustments: p.error.main,
    approvals: p.primary.main,
    billing: theme.palette.mode === 'dark' ? p.warning.light : p.warning.dark,
  };
}
